import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * AI suggestions are always rendered in this neutral panel so they never look like
 * confirmed data. Everything inside must be editable/confirmable by the user.
 */
export const AiPanel = ({ title, children, onAccept, onReject, acceptLabel = "Bruk forslag", rejectLabel = "Avvis", busy = false, meta, example = false, testId = "ai-suggestion-panel", footer }) => (
  <section className="ai-panel" data-testid={testId} aria-label="Forslag fra KI">
    <header className="flex flex-wrap items-center justify-between gap-2">
      <span className="ai-label" data-testid="ai-suggestion-label"><Sparkles className="h-3.5 w-3.5" /> {example ? "Eksempel – ikke KI-analyse" : "Forslag fra KI"}</span>
      {meta && <span className="t-meta">{meta}</span>}
    </header>
    {title && <h3 className="mt-2 text-[15px] font-semibold">{title}</h3>}
    <div className="mt-2 space-y-3 text-[14.5px] leading-relaxed">{children}</div>
    {(onAccept || onReject || footer) && (
      <footer className="mt-3 flex flex-wrap items-center gap-2">
        {onAccept && <Button size="sm" onClick={onAccept} disabled={busy} data-testid="ai-suggestion-accept-button">{acceptLabel}</Button>}
        {onReject && <Button size="sm" variant="outline" onClick={onReject} disabled={busy} data-testid="ai-suggestion-reject-button">{rejectLabel}</Button>}
        {footer}
      </footer>
    )}
    <p className="t-meta mt-3">Forslaget må kontrolleres og bekreftes. KI endrer ikke godkjent grunnlag og frigir ingenting.</p>
  </section>
);

export const AiSource = ({ quote, label = "Fra beskjeden" }) =>
  quote ? (
    <p className="ai-source" data-testid="ai-source-quote"><span className="font-medium">{label}:</span> «{quote}»</p>
  ) : null;
